module.exports = __webpack_public_path__ + "static/food5-7e3ba82e28842b4c3fe2cf1a596aaafe.jpg";